<div
  class="form-group"
  [formGroup]="formGroup!"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
    @if (config ? showAsterisk(config) : false) {
      *
    }
  </label>

  <div
    class="form-check-group"
    [ngClass]="getCheckGroupDisplayTypeClass()"
  >
    @for (item of config?.options; track item; let i = $index; let first = $first) {
      <div
        class="form-check"
        [ngClass]="getCheckDisplayTypeClass(first)"
      >
        <input
          name="{{ config?.name }}"
          id="{{ (config?.name ?? '') + i }}"
          class="form-check-input"
          type="radio"
          [ngClass]="getInputDisplayTypeClass()"
          [formControlName]="config?.name ?? ''"
          [value]="item.value"
          (change)="onChange(item.value)"
        />
        <label
          for="{{ (config?.name ?? '') + i }}"
          class="form-check-label"
          [ngClass]="getLabelDisplayTypeClass(item)"
        >
          {{ item.text }}
        </label>
      </div>
    }
  </div>

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
